import React from "react";
import TagAndPillsContainer from "../../Componant/Ui Kit/TagAndPills";

const TagAndPills = () => {
  return (
    <div className="page-body">
        <TagAndPillsContainer/>
    </div>

  )
};

export default TagAndPills;
